'use strict';

module.exports = {
  ...require('./email'),
};
